import React, { useEffect, useState } from "react";
import { Copy, Check, ExternalLink, Clock, RefreshCw, XCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { C, FONT } from "../kota/ui";

export const rupiah = n => "Rp " + Number(n || 0).toLocaleString("id-ID");

// Kartu bayar Toa lewat Saweria: kode pesanan (disalin), nominal minimal, tombol buka Saweria, status dipantau tiap 5 dtk
// sampai webhook Saweria menandai lunas → onLunas(hasil) menampilkan kartu "Toa-mu antre".
export function ToaBayar({ token, pesanan: awal, onLunas, onBatal }) {
  const [p, setP] = useState(awal);
  const [disalin, setDisalin] = useState(false);
  const sisa = Math.max(0, Math.floor((new Date(p.kedaluwarsa_at).getTime() - Date.now()) / 60000));

  useEffect(() => {
    if (p.status !== "menunggu") return;
    const t = setInterval(() => api.toaPesanan(token, p.id).then(d => {
      setP(d.pesanan);
      if (d.pesanan.status === "lunas") { toast.success("Sawer diterima — Toa-mu masuk antrean!"); onLunas({ toa: d.pesanan.toa, tunggu_detik: d.pesanan.tunggu_detik ?? 0 }); }
    }).catch(() => {}), 5000);
    return () => clearInterval(t);
  }, [p.id, p.status, token, onLunas]);

  const salin = async () => { try { await navigator.clipboard.writeText(p.kode); setDisalin(true); setTimeout(() => setDisalin(false), 1500); } catch { toast(p.kode); } };
  const kedaluwarsa = p.status === "kedaluwarsa";

  return (
    <div data-testid="toa-bayar" style={{ marginTop: 14, padding: "14px 16px", borderRadius: 18, background: C.cream, border: `1.5px solid ${kedaluwarsa ? C.danger : C.blue}`, fontFamily: FONT }}>
      <b style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: kedaluwarsa ? C.danger : C.blue }}>
        {kedaluwarsa ? <><XCircle size={16} /> Pesanan kedaluwarsa</> : <><Clock size={16} /> Sawer untuk menayangkan Toa</>}
      </b>
      {kedaluwarsa ? (
        <p style={{ margin: "6px 0 0", fontSize: 12.5, color: C.sub, lineHeight: 1.5 }}>Kode tidak dibayar dalam 30 menit. Tulis ulang Toa-mu untuk mendapat kode baru.</p>
      ) : (
        <>
          <p style={{ margin: "6px 0 10px", fontSize: 12.5, color: C.sub, lineHeight: 1.5 }}>
            Sawer minimal <b style={{ color: C.ink }}>{rupiah(p.min_rp)}</b> di Saweria dan tulis kode di bawah pada kolom <b style={{ color: C.ink }}>pesan</b>. Begitu sawer masuk, Toa-mu otomatis antre.
          </p>
          <button data-testid="toa-kode" onClick={salin} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", borderRadius: 14, border: `1.5px dashed ${C.blue}`, background: "#fff", cursor: "pointer", fontFamily: FONT }}>
            <span style={{ fontSize: 20, fontWeight: 800, letterSpacing: 2, color: C.ink, fontFamily: "ui-monospace, monospace" }}>{p.kode}</span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 700, color: C.blue }}>{disalin ? <><Check size={13} /> Disalin</> : <><Copy size={13} /> Salin</>}</span>
          </button>
          <a data-testid="toa-buka-saweria" href={p.url} target="_blank" rel="noopener noreferrer"
            style={{ marginTop: 10, width: "100%", height: 46, borderRadius: 16, background: C.blue, color: "#fff", fontWeight: 800, fontSize: 13.5, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, textDecoration: "none" }}>
            <ExternalLink size={15} /> Buka Saweria
          </a>
          <p data-testid="toa-bayar-status" style={{ margin: "10px 0 0", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, fontSize: 11.5, color: C.sub }}>
            <RefreshCw size={11} className="spin" /> Menunggu sawer masuk · kode berlaku {sisa} mnt lagi{p.catatan ? ` · ${p.catatan}` : ""}
          </p>
        </>
      )}
      <button data-testid="toa-bayar-batal" onClick={onBatal} style={{ marginTop: 10, width: "100%", height: 40, borderRadius: 14, border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontWeight: 700, fontSize: 12.5, cursor: "pointer", fontFamily: FONT }}>
        {kedaluwarsa ? "Tulis ulang" : "Ubah pesan"}
      </button>
    </div>
  );
}
